<template>
  <Modal @opened="opened($event)" @closed="closed()" :size="'xl'" :modalId="modalId">
    <template #header>
      <div class="ifttt-header">
        <div class="ifttt-header-info">
          {{  $t('ifttt.createIfttt.pageTitle') }}
        </div>
        <div type="button" class="modal-close-button" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="far fa-times-circle"></i></span> {{  $t('ui.close') }}
        </div>
      </div>
    </template>

    <template #body>
      <div class="ifttt-details">
        <IftttForm v-if="modalOpen" @closeModal="closeModal($event)"></IftttForm>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from "@/components/general/Modal.vue";
import {mapGetters} from "vuex";
import IftttForm from "@/components/ifttt/IftttForm.vue";

export default {
  name: "CreateIfttt",
  props: ['modalId'],
  data() {
    return {
      iftttId: null,
      modalOpen: false
    }
  },
  components: {
    IftttForm,
    Modal
  },
  computed: {
  },
  methods: {
    opened(event) {
      this.modalOpen = true;
    },
    closed() {
      this.modalOpen = false;
    },
    closeModal($event) {
      window.$('#' + this.modalId).modal('hide');
      this.swalToastSuccess(this.$t('ifttt.createIfttt.saved'));
    }
  }
}
</script>

<style scoped>

.ifttt-header {
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  width: 100%;
}

.ifttt-header-info {
  display: inline-block;
}

.ifttt-header {
  color: black;
}

</style>